import React from 'react'
import { Link } from "react-router-dom";


const Dermatology = () => {
    return (
        <>
            <div className="dz-bnr-inr dz-banner-dark overlay-secondary-middle dz-bnr-inr-md" style={{ background: "url(./assets/img/Hospital.jpg)" }}>
                <div className="container">
                    <div className="dz-bnr-inr-entry d-table-cell">
                        <h1 className="" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp', color: "white" }}>त्वचा विशेषज्ञ</h1>
                        <nav aria-label="breadcrumb" className="breadcrumb-row wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <ul className="">
                                <li className="breadcrumb-item"><Link to="/">होम</Link></li>
                                <li className="breadcrumb-item">त्वचा विशेषज्ञ</li>
                            </ul>
                        </nav>
                        <div className="dz-btn">
                            <a to="tel:+91 9165155945" className="btn btn-lg btn-icon btn-primary radius-xl btn-shadow mb-3 mb-sm-0">
                                <span className="left-icon">
                                    <i className="feather icon-phone-call" />
                                </span>
                                +91 9165155945
                            </a>
                        </div>
                    </div>
                </div>
                <span className="text-vertical">24/7 आपातकालीन सेवा</span>
                <ul className="dz-social">
                    <li>
                        <Link to="https://www.facebook.com/p/Omkar-Multispeciality-Hospital-61578676481836/" target="_blank">
                            <i className="fa-brands fa-facebook-f" />
                        </Link>
                    </li>
                    <li>
                        <a to="https://www.instagram.com" target="_blank">
                            <i className="fa-brands fa-instagram" />
                        </a>
                    </li>

                    <li>
                        <a to="https://twitter.com" target="_blank">
                            <i className="fa-brands fa-x-twitter" />
                        </a>
                    </li>
                    <li>
                        <a to="https://www.youtube.com" target="_blank">
                            <i className="fa-brands fa-youtube" />
                        </a>
                    </li>
                </ul>
            </div>

            <section className="content-inner service-single">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 single-inner order-lg-1">
                            <div className="single-media dz-media single-media height-sm radius-lg wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.1s', animationName: 'fadeInUp' }}>
                                <img src="./assets/img/Dermatology_1.webp" alt className="object-fit-cover" />
                            </div>
                            <div className="content-item wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                <h2>त्वचा विशेषज्ञ</h2>
                                <p>
                                    हमारा त्वचा विशेषज्ञ डिपार्टमेंट सभी तरह की स्किन, बालों और नाखूनों की कंडीशन के लिए पूरी देखभाल देने के लिए डेडिकेटेड है। हम सभी उम्र के मरीज़ों के लिए हेल्दी और चमकदार स्किन पक्का करने के लिए सही डायग्नोसिस, एडवांस्ड ट्रीटमेंट ऑप्शन और पर्सनलाइज़्ड केयर पर फोकस करते हैं।

                                    स्किन शरीर का सबसे बड़ा ऑर्गन है और आपको इन्फेक्शन और एनवायरनमेंटल डैमेज से बचाने में अहम रोल निभाती है। हमारे एक्सपीरियंस्ड डर्मेटोलॉजिस्ट लेटेस्ट मेडिकल टेक्नोलॉजी और एविडेंस-बेस्ड ट्रीटमेंट का इस्तेमाल करके आम और कॉम्प्लेक्स स्किन डिसऑर्डर, दोनों को मैनेज करने के लिए ट्रेंड हैं।
                                </p>
                            </div>
                            <div className="content-item wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.3s', animationName: 'fadeInUp' }}>
                                <h3>हम इन स्थितियों का इलाज करते हैं</h3>
                                <ul className="text-secondary grid-2 m-b30">
                                    <li>  ✅   मुंहासों, पिंपल्स और निशानों का इलाज </li>
                                    <li>  ✅   एक्जिमा, सोरायसिस और डर्मेटाइटिस का मैनेजमेंट </li>
                                    <li>  ✅   फंगल और बैक्टीरियल स्किन इन्फेक्शन </li>
                                    <li>  ✅ बालों का झड़ना और स्कैल्प की बीमारियां   </li>
                                    <li>  ✅   नाखूनों की बीमारियां </li>
                                    <li>  ✅   स्किन की एलर्जी और रैशेज </li>
                                    <li>  ✅   पिगमेंटेशन की समस्याएं और मेलास्मा </li>
                                    <li>  ✅   स्किन बायोप्सी और छोटी-मोटी सर्जिकल प्रक्रियाएं </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-4 m-b30">
                            <aside className="side-bar sticky-top left">
                                <div className="widget service_menu_nav bg-secondary wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                    <div className="widget-title">
                                        <h4 className="title">सभी सेवाएँ</h4>
                                    </div>
                                    <ul>
                                        <li className="active" ><Link to="/dermatology">त्वचा विशेषज्ञ</Link></li>
                                        <li><Link to="/pulmonology">पल्मोनोलॉजी</Link></li>
                                        <li><Link to="/ent">कान, नाक और गले</Link></li>
                                        <li><Link to="/paediatrics">बाल चिकित्सा</Link></li>
                                        <li><Link to="/gynaecology">प्रसूति एवं स्त्री रोग</Link></li>
                                        <li ><Link to="/dental">डेंटल</Link></li>
                                        <li><Link to="/general-medicine">सामान्य दवा</Link></li>
                                        <li><Link to="/general-surgery">जनरल सर्जरी</Link></li>
                                        <li><Link to="/orthopedic">ऑर्थोपेडिक</Link></li>
                                        <li><Link to="/physiotherapy">फिजियोथेरेपी</Link></li>
                                        <li ><Link to="/urology">यूरोलॉजी</Link></li>
                                        <li><Link to="/anaesthesiology">एनेस्थिसियोलॉजी</Link></li>
                                        <li><Link to="/general-medicine">जनरल मेडिसिन</Link></li>
                                    </ul>
                                </div>
                                <div className="widget_contact" style={{ backgroundImage: 'url(./assets/images/background/bg3.png)' }} data-wow-delay="0.4s" data-wow-duration="0.7s">
                                    <div className="widget-content">
                                        <img src="./assets/images/question.png" width={80} alt />
                                        <h4 className="title">क्या आपको किसी मदद की ज़रूरत है?</h4>
                                        <div className="phone-number">
                                            <a href="tel:+919165155945">+91 9165155945</a>
                                        </div>
                                        <div className="email">
                                            <a href="mailto:omkarmultispecialityhospital1@gmail.com">omkarmultispecialityhospital1
                                                @gmail.com</a>
                                        </div>
                                        <div className="link-btn">
                                            <a to="/contact-us" className="btn btn-lg btn-icon btn-white hover-secondary btn-shadow">
                                                Contact Us <span className="right-icon"><i className="feather icon-arrow-right" /></span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </aside>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default Dermatology